import { createSlice } from "@reduxjs/toolkit";
import { GetRequisitionTypes } from "services/dropdown/dropdown.service";
import { toast } from 'react-toastify';

export const requisitionTypeSlice = createSlice({
  name: "requisitionTypes",
  initialState: {
    requisitionTypeList: [],
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(GetRequisitionTypes.pending, () => {
      // toast.success('Promise Pending 🤯');
    });

    builder.addCase(GetRequisitionTypes.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('Promise resolved 👌');
      state.requisitionTypeList = action.payload
    });

    builder.addCase(GetRequisitionTypes.rejected, () => {
      toast.dismiss();
      toast.error('Promise rejected 😣')

    });
  },
});

export default requisitionTypeSlice.reducer;
